import React, { useState } from 'react';
import './Reports.css';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


function Reports() {
    const [modalShow, setModalShow] = React.useState(false);
    return (<>
        <div className="community-section">
            <div className="community-inner-wrap subscriptions-block d-flex align-items-center justify-content-between">
                <div className="add-new-community d-flex justify-content-between align-items-center mb-0">
                    <div className="community-heading">Reports</div>
                </div>
                <div className='services-dropdown-box d-flex gap-3 align-items-center justify-content-end'>
                    <div className="dropdown-filter">
                        <select>
                            <option value="" disabled selected>Florida</option>
                            <option value="option1">Option 1</option>
                            <option value="option2">Option 2</option>
                            <option value="option3">Option 3</option>
                        </select>
                    </div>
                    <div className="dropdown-filter">
                        <select>
                            <option value="" disabled selected>All Services</option>
                            <option value="option1">Option 1</option>
                            <option value="option2">Option 2</option>
                            <option value="option3">Option 3</option>
                        </select>
                    </div>
                    <div className="dropdown-filter">
                        <select>
                            <option value="" disabled selected>February</option>
                            <option value="option1">Option 1</option>
                            <option value="option2">Option 2</option>
                            <option value="option3">Option 3</option>
                        </select>
                    </div>
                    <div className="dropdown-filter">
                        <select>
                            <option value="" disabled selected>2025</option>
                            <option value="option1">Option 1</option>
                            <option value="option2">Option 2</option>
                            <option value="option3">Option 3</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className="all-commmunities-table">
                {/* <div className='billing-title allcommunities'>
                    Client Search
                </div> */}
                {/* <div className='input-search mt-2'>
                    <input type="text" placeholder="Start Typing here..." />
                </div> */}
                <div className='payments-table reports'>
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col">Date</th>
                                <th scope="col">Type</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Detail</th>
                            </tr>
                        </thead>
                        <tbody className="table-group-divider">
                            <tr className='month'>
                                <td>February 2025</td>
                            </tr>
                            <tr>
                                <td>2/2/2035</td>
                                <td>Realtor</td>
                                <td>$9.76</td>
                                <td><div>
                                    <div className='credit-icon' onClick={() => setModalShow(true)}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg" month border-top
                                            version="1.1"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 60 60"
                                            style={{ enableBackground: 'new 0 0 512 512' }}
                                            xmlSpace="preserve"
                                        >
                                            <g>
                                                <g fill="#fff">
                                                    <path
                                                        d="M32.414 58.414l5.354-5.354A10.945 10.945 0 0 0 44 55c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11c0 2.315.719 4.46 1.94 6.232l-5.354 5.354zM37 44a7 7 0 1 1 14 0 7 7 0 0 1-14 0z"
                                                        fill="#ffffff"
                                                        opacity="1"
                                                    ></path>
                                                    <path
                                                        d="M25.516 54l4.521-4.521A14.913 14.913 0 0 1 29 44c0-8.271 6.729-15 15-15 2.942 0 5.682.864 8 2.333V5a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v47a2 2 0 0 0 2 2zM45 21H15v-4h30zm0-8H15V9h30z"
                                                        fill="#ffffff"
                                                        opacity="1"
                                                    ></path>
                                                </g>
                                            </g>
                                        </svg>

                                    </div>
                                </div></td>
                            </tr>
                            <tr>
                                <td>2/2/2035</td>
                                <td>Ad Banner</td>
                                <td>$9.76</td>
                                <td><div>
                                    <div className='credit-icon' onClick={() => setModalShow(true)}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.1"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 60 60"
                                            style={{ enableBackground: 'new 0 0 512 512' }}
                                            xmlSpace="preserve"
                                        >
                                            <g>
                                                <g fill="#fff">
                                                    <path
                                                        d="M32.414 58.414l5.354-5.354A10.945 10.945 0 0 0 44 55c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11c0 2.315.719 4.46 1.94 6.232l-5.354 5.354zM37 44a7 7 0 1 1 14 0 7 7 0 0 1-14 0z"
                                                        fill="#ffffff"
                                                        opacity="1"
                                                    ></path>
                                                    <path
                                                        d="M25.516 54l4.521-4.521A14.913 14.913 0 0 1 29 44c0-8.271 6.729-15 15-15 2.942 0 5.682.864 8 2.333V5a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v47a2 2 0 0 0 2 2zM45 21H15v-4h30zm0-8H15V9h30z"
                                                        fill="#ffffff"
                                                        opacity="1"
                                                    ></path>
                                                </g>
                                            </g>
                                        </svg>

                                    </div>
                                    <MyVerticallyCenteredModal
                                        show={modalShow}
                                        onHide={() => setModalShow(false)}
                                    />
                                </div></td>
                            </tr>
                            <tr className='month border-top '>
                                <td>Total</td>
                                <td></td>
                                <td><span>$</span>19.52</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </>);
}
function MyVerticallyCenteredModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered className='reports-modal'
        >
            <Modal.Header closeButton className='pb-0'>
            </Modal.Header>
            <Modal.Body className='p-0'>
                <div className='title-modal'>Ad Banner</div>
                <div className=''>
                    <div className='table-modal'>
                        <table className="table table-borderless">
                            <tbody>
                                <tr>
                                    <td>2/3/2025</td>
                                    <td>Miller Ale House</td>
                                    <td>Jupiter FL</td>
                                    <td>$79.95</td>
                                </tr>
                                <tr>
                                    <td>2/3/2025</td>
                                    <td>State Farm Insurance</td>
                                    <td>Jupiter FL</td>
                                    <td>$79.95</td>
                                </tr>
                                <tr>
                                    <td>2/3/2025</td>
                                    <td>Jupiter Medical Center</td>
                                    <td>Stuart FL</td>
                                    <td>$79.95</td>
                                </tr>
                                <tr>
                                    <td>2/3/2025</td>
                                    <td>Keller Williams Realty</td>
                                    <td>Stuart FL</td>
                                    <td>$79.95</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal.Body>
            {/* <Modal.Footer>
                <Button onClick={props.onHide} className="orange-filled-btn closebtn">Submit</Button>
            </Modal.Footer> */}
        </Modal>
    );
}

export default Reports;